import React, { useContext, useEffect, Fragment } from 'react'
import { useLazyQuery } from '@apollo/client'
import AutocompleteComponent from '../../../components/filters/AutocompleteComponent'
import { GET_STATUS_FILTER } from '../../../queries/factory'
import { FactoryFiltersContext } from '../../../context/FactoryFiltersContext'

export default function Status (): JSX.Element {
  const { filters, setFilters } = useContext(FactoryFiltersContext)
  const [getData, { data }] = useLazyQuery(
    GET_STATUS_FILTER, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    if (filters.factory) {
      getData({
        variables: { filters }
      })
    }
  }, [filters])

  const onChange = (value: string[]) => {
    setFilters({
      newOrderStatus: value
    })
  }

  const statuses: Array<string> = []

  data?.aggregation?.aggregations?.status?.buckets.map((status: any) => {
    statuses.push(status.key)
  })

  const typographLabel = 'Status'

  return (
    <Fragment>
      <AutocompleteComponent
        labelValue={typographLabel}
        data={statuses}
        defaultValues={filters?.newOrderStatus}
        onChange={onChange}
      />
    </Fragment>
  )
}
